// extracted by mini-css-extract-plugin
export default {"no-items":"noItemsMessage_no-items__noAPD","no-items__button":"noItemsMessage_no-items__button__Uzb1P","no-items--light":"noItemsMessage_no-items--light__Bmuzr"};